import useCategoryBaseActions from './useCategoryBaseActions'

export default useCategoryBaseActions
